import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

/**
 * Thin wrapper over the self-hosted Umami tracker (window.umami), loaded via
 * the <script> tag in index.html against the first-party /umami/* proxy (see
 * src/_redirects) rather than umami.notionhabitheroes.com directly, so ad/
 * tracker blockers targeting third-party analytics hosts don't strip it.
 *
 * Umami's `umami.track(name, data)` takes a flat data object — unlike
 * Plausible's `plausible(name, {props})`, there is no nesting. SSR-safe via
 * isPlatformBrowser; no-ops if the global is absent (e.g. before the script
 * has loaded, or if it's blocked) so every trackEvent() call site stays valid
 * regardless of tracker availability.
 */
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  trackEvent(name: string, props?: Record<string, string | number | boolean>): void {
    if (!this.isBrowser) {
      return;
    }
    const umami = (window as any).umami;
    if (!umami) {
      return;
    }
    if (props) {
      umami.track(name, props);
    } else {
      umami.track(name);
    }
  }
}
